import { StanModal } from '@/components';
import { StanTipTapEditor } from '@/components/core-components/StanTipTapEditor/StanTipTapEditor';
import { stanAnalytics } from '@/lib';
import { useUser } from '@/queries/useUser';

interface AffiliateLinkSetupModalProps {
    isOpen: boolean;
    onClose: () => void;
    terms: string;
    linkId: number;
    onAgree: () => void;
    isLoading?: boolean;
}

export function AffiliateLinkSetupModal({
    isOpen,
    onClose,
    terms,
    linkId,
    onAgree,
    isLoading = false,
}: AffiliateLinkSetupModalProps) {
    const { user } = useUser();

    const handleAgree = () => {
        // Track analytics
        stanAnalytics('affiliate-terms-and-condition-agreed', {
            meta: { user_id: user?.user_id, username: user?.username },
            props: {
                termAndConditions: terms,
                resell_rights_id: linkId,
            },
        });

        onAgree();
    };

    return (
        <StanModal
            id='affiliate-link-setup-modal'
            isOpen={isOpen}
            onClose={onClose}
            title='Agree to Terms & Conditions'
            size='lg'
            primaryActionLabel='I Agree'
            onPrimaryAction={handleAgree}
            primaryActionLoading={isLoading}
            primaryActionDisabled={isLoading}
        >
            <div className='flex flex-col gap-4'>
                {/* Subheading */}
                <div className='flex items-center justify-center'>
                    <p className='text-body-2-regular text-text-secondary w-4/5 text-center'>
                        Before accessing your affiliate link, please review and agree to the terms and conditions for
                        promoting this product.
                    </p>
                </div>

                {/* Terms and Conditions Viewer */}
                <div className='bg-brand-dimmed flex flex-col items-end gap-1 self-stretch rounded-lg p-4'>
                    <StanTipTapEditor
                        value={terms}
                        onChange={() => {}}
                        disabled
                        hideToolbar
                        imageUploadAllowed={false}
                        videoAllowed={false}
                        linkAllowed={false}
                        generateAiAllowed={false}
                        personalizeItemData={[]}
                        allowAddProductLink={false}
                        placeholder=''
                    />
                </div>

                {/* Agreement Notice */}
                <p className='text-caption-2-regular text-text-secondary mt-2 text-center'>
                    By clicking &apos;I Agree,&apos; you acknowledge that you have read and accepted the terms and
                    conditions for promoting this affiliate product.
                </p>
            </div>
        </StanModal>
    );
}
